// ... existing code ...

export default function InteractiveMap() {
  const stats = [
    { 
      label: 'Square Miles', 
      value: '42.3', 
      icon: 'ri-map-2-line',
      source: 'City of Roseville' 
    },
    { 
      label: 'Neighborhoods', 
      value: '50+', 
      icon: 'ri-community-line',
      source: 'Planning Department' 
    },
    { 
      label: 'Parks & Trails', 
      value: '80+', 
      icon: 'ri-plant-line',
      source: 'Parks & Recreation Dept.' 
    },
    { 
      label: 'Miles of Trails', 
      value: '42', 
      icon: 'ri-route-line',
      source: 'Parks & Recreation Dept.' 
    },
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-teal-600 font-semibold text-sm mb-3 tracking-wide uppercase">Explore Roseville</p>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Discover Your Perfect Neighborhood
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            From historic downtown charm to modern master-planned communities, Roseville offers diverse neighborhoods to match every lifestyle
          </p>
        </div>

        {/* Stats Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12">
          {stats.map((stat) => (
            <div key={stat.label} className="bg-gradient-to-br from-teal-50 to-amber-50 rounded-xl p-6 text-center border border-gray-100">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-white mx-auto mb-3 shadow-sm">
                <i className={`${stat.icon} text-teal-600 text-xl`}></i>
              </div>
              <p className="text-3xl font-bold text-gray-900 mb-1">{stat.value}</p>
              <p className="text-sm text-gray-600 mb-1">{stat.label}</p>
              <p className="text-[10px] text-gray-400">Source: {stat.source}</p>
            </div>
          ))}
        </div>

        {/* Map Container */}
        <div className="rounded-2xl overflow-hidden shadow-xl border border-gray-200 h-[600px]">
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d50234.89384847891!2d-121.32820843124999!3d38.75208799999999!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x809b1f6b6e6e6e6f%3A0x6e6e6e6e6e6e6e6e!2sRoseville%2C%20CA!5e0!3m2!1sen!2sus!4v1234567890123"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Roseville California Interactive Map"
          ></iframe>
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <a 
            href="/neighborhoods" 
            className="inline-flex items-center gap-2 bg-teal-600 hover:bg-teal-700 text-white px-8 py-4 rounded-lg text-base font-semibold transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-map-pin-line text-xl"></i>
            Explore All Neighborhoods
          </a>
        </div>

        {/* Data Sources Note */}
        <div className="mt-8 text-center">
          <p className="text-xs text-gray-400 leading-relaxed max-w-3xl mx-auto">
            <strong>Data Sources:</strong> Geographic and demographic data from City of Roseville Planning Department and Parks & Recreation Department. Map data © Google. Statistics updated annually.
          </p>
        </div>
      </div>
    </section>
  );
}
